import { AlertRule } from '@analyzer/core/lib/rules/alert.js';
import { Box, List, ListItem, Typography } from '@mui/material';

export function ExpressionComponent(props: { expression: any }) {
  const { expression } = props;

  switch (expression.type) {
    case 'in':
    case 'matches':
      return <code>{`${expression.type}(${expression.field}, ${expression.value})`}</code>;
    case 'and':
    case 'or':
      return (
        <>
          <code>{`${expression.type}(`}</code>
          <List>
            {expression.operands.map((operand: string, index: number) => (
              <ListItem key={index}>
                <ExpressionComponent expression={operand} />
              </ListItem>
            ))}
          </List>
          <code>)</code>
        </>
      );
    case 'not':
      return (
        <List>
          <code>
            not <ExpressionComponent expression={expression.operand} />
          </code>
        </List>
      );
    case 'true':
      return <code>true</code>;
    case 'false':
      return <code>false</code>;
    default:
      return null;
  }
}

export function RuleComponent(props: { rule: AlertRule }) {
  const { rule } = props;

  return (
    <Box>
      <Typography variant="subtitle2">Action</Typography>
      <code>{rule.action}</code>
      <Typography variant="subtitle2">Predicate</Typography>
      <ExpressionComponent expression={rule.predicate} />
    </Box>
  );
}
